
import { Component, Mixins } from "vue-property-decorator";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";
import OfficeProfileMixin from "../../office-profiles.mixin";
import { OfficeHourFormDto } from "@/types/office.type";
import { DayOfWeek } from "@/types/enums.type";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState("OfficeProfile", ["hourForm"])
  }
})
export default class OfficeHoursEditComponent extends Mixins(OfficeProfileMixin, ValidatedFormMixin) {
  hourForm!: OfficeHourFormDto;

  DayOfWeek = DayOfWeek;

  mounted(): void {
    if (this.isEdit && this.selectedOffice) {
      this.$store.commit("OfficeProfile/updateField", {
        path: "hourForm",
        value: {
          officeId: this.selectedOffice.id,
          mondayOpenTime: this.getOpenTime(DayOfWeek.Monday, this.selectedOffice.hours),
          mondayCloseTime: this.getCloseTime(DayOfWeek.Monday, this.selectedOffice.hours),
          mondayBreakMinutes: 0,
          tuesdayOpenTime: this.getOpenTime(DayOfWeek.Tuesday, this.selectedOffice.hours),
          tuesdayCloseTime: this.getCloseTime(DayOfWeek.Tuesday, this.selectedOffice.hours),
          tuesdayBreakMinutes: 0,
          wednesdayOpenTime: this.getOpenTime(DayOfWeek.Wednesday, this.selectedOffice.hours),
          wednesdayCloseTime: this.getCloseTime(DayOfWeek.Wednesday, this.selectedOffice.hours),
          wednesdayBreakMinutes: 0,
          thursdayOpenTime: this.getOpenTime(DayOfWeek.Thursday, this.selectedOffice.hours),
          thursdayCloseTime: this.getCloseTime(DayOfWeek.Thursday, this.selectedOffice.hours),
          thursdayBreakMinutes: 0,
          fridayOpenTime: this.getOpenTime(DayOfWeek.Friday, this.selectedOffice.hours),
          fridayCloseTime: this.getCloseTime(DayOfWeek.Friday, this.selectedOffice.hours),
          fridayBreakMinutes: 0,
          saturdayOpenTime: this.getOpenTime(DayOfWeek.Saturday, this.selectedOffice.hours),
          saturdayCloseTime: this.getCloseTime(DayOfWeek.Saturday, this.selectedOffice.hours),
          saturdayBreakMinutes: 0,
          sundayOpenTime: this.getOpenTime(DayOfWeek.Sunday, this.selectedOffice.hours),
          sundayCloseTime: this.getCloseTime(DayOfWeek.Sunday, this.selectedOffice.hours),
          sundayBreakMinutes: 0
        } as OfficeHourFormDto 
      });
    }

    this.$validator.reset();
  }

  async update(): Promise<void> {
    await this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.setLoading(true);

        this.fixForm();
        
        await this.$store.dispatch("OfficeProfile/saveOfficeHours", this.hourForm);

        this.setLoading(false);
      }
    });
  }

  fixForm(): void {
    this.$store.commit("OfficeProfile/updateField", {
        path: "hourForm",
        value: {
          ...this.hourForm,
          mondayOpenTime: this.hourForm.mondayOpenTime ? this.hourForm.mondayOpenTime : null,
          mondayCloseTime: this.hourForm.mondayCloseTime ? this.hourForm.mondayCloseTime : null,
          tuesdayOpenTime: this.hourForm.tuesdayOpenTime ? this.hourForm.tuesdayOpenTime : null,
          tuesdayCloseTime: this.hourForm.tuesdayCloseTime ? this.hourForm.tuesdayCloseTime : null,
          wednesdayOpenTime: this.hourForm.wednesdayOpenTime ? this.hourForm.wednesdayOpenTime : null,
          wednesdayCloseTime: this.hourForm.wednesdayCloseTime ? this.hourForm.wednesdayCloseTime : null,
          thursdayOpenTime: this.hourForm.thursdayOpenTime ? this.hourForm.thursdayOpenTime : null,
          thursdayCloseTime: this.hourForm.thursdayCloseTime ? this.hourForm.thursdayCloseTime : null,
          fridayOpenTime: this.hourForm.fridayOpenTime ? this.hourForm.fridayOpenTime : null,
          fridayCloseTime: this.hourForm.fridayCloseTime ? this.hourForm.fridayCloseTime : null,
          saturdayOpenTime: this.hourForm.saturdayOpenTime ? this.hourForm.saturdayOpenTime : null,
          saturdayCloseTime: this.hourForm.saturdayCloseTime ? this.hourForm.saturdayCloseTime : null,
          sundayOpenTime: this.hourForm.sundayOpenTime ? this.hourForm.sundayOpenTime : null,
          sundayCloseTime: this.hourForm.sundayCloseTime ? this.hourForm.sundayCloseTime : null,
       } as OfficeHourFormDto
    });
  }

  back(): void {
    this.$emit('update:activeTab', 1);
  }

  next(): void {
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.fixForm();

        this.$emit('update:activeTab', 3);
      }
    });
  }
}
